import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { AuthState, FrmLogin } from "./types";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";

type AuthActionContext = ActionContext<AuthState, RootState>;
type AuthActionTree = ActionTree<AuthState, RootState>;

export const actions: AuthActionTree = {
  async login(context: AuthActionContext, payload: FrmLogin): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: "/Auth/Login",
        data: payload,
      });
      context.commit("setUsuario", response.data);
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },
  async checkPassword(context: AuthActionContext, payload: any): Promise<boolean> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: "/Auth/CheckPassword",
        params: payload
      });
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async resetPassword(context: AuthActionContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: "/Auth/ResetPassword",
        params: payload
      });
      return response;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  }
};
